<div *ngIf="insuranceOption" class="mb-6 option-card-wrapper">
    <div class="insurance-option-inner">
        <div
            class="logo-section option-item-section px-3 align-items-center justify-content-center py-2"
        >
            <div
                class="title flex flex-column align-items-center mt-4 justify-content-center"
            >
                <span
                    class="text-xl font-bold mb-3"
                    style="color: rgb(0, 141, 31)"
                    >{{ insuranceOption.providerName }}</span
                >
                @if(blobUrl()===''){
                    <img
                    src="../../../../../assets/demo/images/car-insurance.png"
                    width="80px"
                    height="80px"
                    class="p-2 mt-2"
                    style="
                        background-color: rgb(236, 236, 236);
                        border-radius: 50%;
                    "
                />
                }@else {
                    <img
                    [src]="blobUrl()"
                    width="100px"
                    height="90px"
                    class="p-2 mt-2"/>
                }

                <span class="text-md font-semibold text-500 mt-4">{{
                    insuranceOption.packageName
                }}</span>
            </div>
        </div>
        <div
            class="premiums-section option-item-section flex flex-column gap-2 px-3 py-2"
        >
            <span class="text-500 font-bold">{{
                "Premium Due" | translate
            }}</span>
            <span class="text-xl font-bold">{{
                insuranceOption.premiumDue | currency : "MZN"
            }}</span>
            <span class="mt-4 text-500 text-xs text-align-center"
                >{{ "at" | translate }}
                <span class="font-bold text-700">{{
                    insuranceOption.annualPremium | currency : "MZN"
                }}</span>
                / {{ "year" | translate }}</span
            >
        </div>
        <div class="limits-section option-item-section px-3 py-2">
            <div class="limits-inner-wrapper flex flex-wrap gap-6">
                <div class="limit-content flex-1 flex flex-column">
                    <span class="title limit-title-text">{{
                        "Compensation-limits" | translate
                    }}</span>
                    <div
                        *ngIf="
                            insuranceOption.compensationLimits;
                            else noDeductibles
                        "
                    >
                        <ul
                            class="flex flex-column"
                            *ngIf="
                                insuranceOption.compensationLimits.length > 0;
                                else noDeductibles
                            "
                        >
                            <li
                                class="my-2"
                                *ngFor="
                                    let item of insuranceOption.compensationLimits
                                "
                            >
                                <div class="flex flex-column">
                                    <span class="text-md limit-name">{{
                                        item.name | translate
                                    }}</span
                                    ><span class="limit-value"
                                        >{{ "Valued at" | translate }}
                                        <span>{{
                                            item.value | currency : "MZN"
                                        }}</span></span
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="limit-content flex-1 flex flex-column">
                    <span class="title limit-title-text">{{
                        "Coverage Extensions" | translate
                    }}</span>
                    <div
                        class="limit-content-item-list"
                        *ngIf="
                            insuranceOption.coverageExtensions;
                            else noDeductibles
                        "
                    >
                        <ul
                            class="flex flex-column"
                            *ngIf="
                                insuranceOption.coverageExtensions.length > 0;
                                else noDeductibles
                            "
                        >
                            <li
                                *ngFor="
                                    let item of insuranceOption.coverageExtensions
                                "
                                class="my-2"
                            >
                                <div class="flex flex-column">
                                    <span class="text-md limit-name">{{
                                        item.name | translate
                                    }}</span
                                    ><span class="limit-value"
                                        >{{ "Valued at" | translate }}
                                        <span>{{
                                            item.value | currency : "MZN"
                                        }}</span></span
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="limit-content flex-1 flex flex-column">
                    <span class="title limit-title-text">{{
                        "Deductibles" | translate
                    }}</span>
                    <div
                        class="limit-content-item-list"
                        *ngIf="insuranceOption.deductibles; else noDeductibles"
                    >
                        <ul
                            class="flex flex-column"
                            *ngIf="
                                insuranceOption.deductibles.length > 0;
                                else noDeductibles
                            "
                        >
                            <li
                                *ngFor="let item of insuranceOption.deductibles"
                                class="my-2"
                            >
                                <div class="flex flex-column">
                                    <span class="text-md limit-name">{{
                                        item.name | translate
                                    }}</span
                                    ><span class="limit-value"
                                        >{{ "Valued at" | translate }}
                                        <span class="font-semibold">{{
                                            item.value | currency : "MZN"
                                        }}</span></span
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <ng-template #noDeductibles>
                        <h2>N/A</h2>
                    </ng-template>
                </div>
            </div>
        </div>
        <div
            class="actions-section flex flex-column justify-content-start align-items-center gap-3 option-item-section px-3 py-4"
        >
            @if (canBeAddedToCart){
            <div
                class="action-button pRipple cart-button"
                (click)="onAddToCart(insuranceOption)"
            >
                <div class="action-icon-wrapper cart-icon">
                    <i class="pi pi-cart-plus" style="color: green"></i>
                </div>
                <span style="color: green">{{
                    "Add to cart" | translate
                }}</span>
            </div>
            } @else {
            <div class="flex gap-2 align-items-start justify-content-start">
                <div class="pi pi-info-circle mt-1" style="color: orange"></div>
                <span class="warning-message text-sm">{{
                    "QUOTATIONS_UPLOAD_VEHICLE_DOCUMENTS_WARNING" | translate
                }}</span>
            </div>
            }

        </div>
    </div>
</div>
